import { render } from "./FieldComp.vue?vue&type=template&id=0d4ca1a4"
import script from "./FieldComp.vue?vue&type=script&lang=js"
export * from "./FieldComp.vue?vue&type=script&lang=js"
script.render = render

export default script
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField});
